import { createFileRoute, Navigate, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useAuth } from "@/lib/auth-context";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/account-disabled")({ component: AccountDisabledPage });

function AccountDisabledPage() {
  const { user, profile, loading, signOut } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  // If somehow an active user lands here, send them to dashboard.
  if (!loading && user && profile && profile.status === "active") {
    return <Navigate to="/dashboard" />;
  }
  // If no session at all, go to login.
  if (!loading && !user) {
    return <Navigate to="/login" />;
  }

  const onLogout = async () => {
    setBusy(true);
    try {
      if (typeof window !== "undefined") {
        sessionStorage.clear();
      }
      await signOut();
    } finally {
      setBusy(false);
      navigate({ to: "/login" });
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F9FAFB] px-4">
      <div className="w-full max-w-[420px] rounded-xl border border-[#E5E7EB] bg-white p-8 text-center shadow-sm">
        <h1 className="text-2xl font-bold text-foreground">Account Deactivated</h1>
        <p className="mt-3 text-sm text-muted-foreground">
          Your account has been deactivated. Please contact Admin if you think this is a
          mistake.
        </p>
        <div className="mt-6 flex justify-center">
          <Button onClick={onLogout} disabled={busy} className="bg-black text-white hover:bg-black/90">
            {busy ? "Logging out…" : "Logout"}
          </Button>
        </div>
      </div>
    </div>
  );
}
